// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var TextFilter$ReactHooksTemplate = require("./textFilter.res.js");
var TextSelected$ReactHooksTemplate = require("./textSelected.res.js");

function TextFilterForm(props) {
  var onChange = props.onChange;
  var filter = props.filter;
  var handleOnChange = function ($$event) {
    Curry._1(onChange, {
          TAG: "FreeText",
          _0: TextFilter$ReactHooksTemplate.setSelected(Caml_option.some(TextSelected$ReactHooksTemplate.make(Utils$ReactHooksTemplate.formTargetValue($$event))), filter)
        });
  };
  return JsxRuntime.jsx("label", {
              children: JsxRuntime.jsx("input", {
                    className: "border border-gray-300 hover:border-gray-400 focus:border-palatinateblue outline-none p-3 mt-4 text-sm bg-transparent w-4/5 rounded",
                    type: "text",
                    value: TextFilter$ReactHooksTemplate.toString(filter),
                    onChange: handleOnChange
                  })
            });
}

var make = TextFilterForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
